import { defineMessages } from "react-intl";

export const messages = defineMessages({
  installAppDescription: {
    id: "ARfw53",
    defaultMessage:
      "Install apps created by Saleor team or install external apps.",
    description: "description",
  },
  installedApps: {
    id: "/PhkXi",
    defaultMessage: "Installed Apps",
    description: "section header",
  },
  ongoingInstallations: {
    id: "nIrjSR",
    defaultMessage: "Ongoing Installations",
    description: "section header",
  },
  allApps: {
    id: "yZB41s",
    defaultMessage: "All Apps",
    description: "section header",
  },
  comingSoonApps: {
    id: "hJDnLg",
    defaultMessage: "Upcoming Apps",
    description: "section header",
  },
  nothingInstalledPlaceholder: {
    defaultMessage: "Nothing installed yet.",
    description: "placeholder",
    id: "9g6Y7a",
  },
});
